<template>
  <div>logout...</div>
</template>

<script setup>
import { useAuthStore } from '@/store/auth'
const authStore = useAuthStore()
authStore.logout()/* .catch((error) => (this.message = error.message)) */
</script>